<template>
  <div class="utility__language">
    <p class="language__current" @mouseup="showLanguageDropDownList" @touchend.prevent="showLanguageDropDownList">
      <span class="current__text">{{ currentLanguageText }}</span>
      <img src="@/assets/images/icon-caret-up-white.svg" alt="열기" />
    </p>

    <ul v-show="isShown" class="language__ul list-style-none">
      <li @mouseup="isShown = false" @touchend.prevent="isShown = false">
        <span class="current__text">{{ currentLanguageText }}</span>
        <img src="@/assets/images/icon-caret-up-red.svg" alt="다국어 선택 아이콘" />
      </li>
      <li
        v-for="(option, index) in languageDropDownList"
        :key="index"
        @mouseup="handleLanguageClick(option.value)"
        @touchend.prevent="handleLanguageClick(option.value)"
      >
        <span class="current__text">{{ option.text }}</span>
      </li>
    </ul>

    <div
      v-if="isShown"
      class="language__backdrop"
      @mouseup="hideLanguageDropDownList"
      @touchend.prevent="hideLanguageDropDownList"
    ></div>
  </div>
</template>

<script setup lang="ts">
  import { LocaleLanguage } from '@/enums/LocaleLanguage';
  import { useConfigStore } from '@/stores/config';
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  const i18n = useI18n();
  const configStore = useConfigStore();

  // 언어 리스트 초기값
  const languages = [
    { value: LocaleLanguage.Ko, text: 'KOR' },
    { value: LocaleLanguage.En, text: 'ENG' },
    { value: LocaleLanguage.Ja, text: '日本語' },
    { value: LocaleLanguage.Zh, text: '中文' },
  ];

  if (configStore.config.CultureName === 'vi-VN') {
    languages.push({ value: LocaleLanguage.Vi, text: 'Tiếng Việt' });
  }

  // 언어 리스트 show/hide
  const isShown = ref(false);

  // 선택된 언어 텍스트
  const currentLanguageText = computed(() => {
    return languages.find((item) => item.value === i18n.locale.value)?.text || 'ENG';
  });

  // 언어 리스트
  const languageDropDownList = computed(() => {
    return (
      languages.filter((item) => {
        return item.value !== i18n.locale.value;
      }) || []
    );
  });

  /** 언어 드랍다운리스트 열기 */
  const showLanguageDropDownList = () => {
    isShown.value = true;
  };

  /** 언어 드랍다운리스트 닫기 */
  const hideLanguageDropDownList = () => {
    isShown.value = false;
  };

  /**
   * 언어 드랍다운리스트 클릭
   * @param languageCode 선택한 언어 코드
   */
  const handleLanguageClick = (languageCode: LocaleLanguage) => {
    i18n.locale.value = languageCode;
    isShown.value = false;
  };
</script>

<style scoped lang="scss">
  .utility__language {
    position: relative;
    margin-right: 20px;
    .language__current {
      display: flex;
      align-items: center;
      .current__text {
        font-size: 14px;
        margin-right: 6px;
        color: #fff;
      }
      img {
        width: 10px;
        transform: rotate(180deg);
      }
    }
    .language__ul {
      position: absolute;
      top: -6px;
      left: -6px;
      z-index: 4;
      padding: 6px;
      background: #fff;
      border: 1px solid #000;
      border-radius: 6px;
      li {
        display: flex;
        align-items: center;
      }
      li + li {
        margin-top: 6px;
      }
      .current__text {
        font-size: 14px;
        margin-right: 6px;
        white-space: nowrap;
        & + img {
          width: 10px;
          transform: rotate(180deg);
        }
      }
    }
    .language__backdrop {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100vh;
    }
  }
</style>
